@if(videos_data | async){
<div
  class="players"
  infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="500"
  (scrolled)="onScroll()"
  [scrollWindow]="true"
>
  @for (item of display_files ; track $index) {
  <div
    [title]="getTitle(item.name)"
    class="player cursor-pointer"
    (click)="
      play_video(item.name, item, searchService.all_search_terms?.corpora?.name)
    "
  >
    <app-small-video-player
      [id]="item._id"
      [sprite_from_db]="false"
      [video_name]="item.name"
      [thumbnail_url]="get_sprite_image(item)"
      [video_data]="get_url_cloud_front(item.metadata.path)"
      [required_additional_options]="false"
      (video_duration)="video_duration($event)"
    >
    </app-small-video-player>
  </div>
  }
</div>
<div class="loading_results" id="current_loader">
  <span class="loader_get_data"></span>
</div>
}
